const keys = {
    API_URL: 'https://api.onlineshopconnector.com', // no trailing slash needed
    FRONTEND_URL: 'https://onlineshopconnector.com',
};

export default keys;
